<template>
  <div class="flex margin-fix mobile-hundred">
    <vx-auto-suggest
      ref="navbarSearch"
      :autoFocus="showFullSearch"
      :data="searchResultData"
      search_key="title"
      background-overlay
      class="regular-label search-bar mobile-hundred"
      inputClassses="mobile-hundred vs-input-no-border vs-input-no-shdow-focus"
      icon="SearchIcon"
      placeholder="Search"
      @input="hnd_search_query_update"
      @selected="selected"
      @closeSearchbar="showFullSearch = false">

      <template v-slot:group="{ group_name }">
        <p class="font-semibold text-primary">{{ group_name | title }}</p>
      </template>

      <!-- Pages Suggestion -->
      <template v-slot:pages="{ suggestion }">
        <div class="flex items-end leading-none py-1">
          <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
          <span class="mt-1">{{ suggestion.title }}</span>
        </div>
      </template>

      <!-- No Items Slot -->
      <template v-slot:noResult="{ group_name }">
        <div class="flex items-start">
          <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
          <span>No results found.</span>
        </div>
      </template>

    </vx-auto-suggest>
    <div id="TheSearchBar" class="search-full-container  absolute" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="text-primary px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'

export default {
  components: {
    VxAutoSuggest
  },
  data () {
    return {
      showFullSearch: false,
      isSearching: false,
      backupQuery: '',
      sentQuery: ''
    }
  },
  methods: {
    selected (item) {
      if (item.products) {
        this.$router.push(item.products.url).then(() => {
          location.reload()
        }).catch(() => {
        })
      }
      if (item.restaurants) {
        this.$router.push(item.restaurants.url).then(() => {
          location.reload()
        }).catch(() => {})
      }

      this.showFullSearch = false
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      if (!this.isSearching) {
        this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
        this.$store.commit('api/SET_CART_BACKGROUND', !!query)
        if (query.length > 1) {

          const payload = {
            page: 1,
            q: query,
            filter: {
              open: 0
            }
          }
          this.isSearching = true
          this.sentQuery = query
          this.$store.dispatch('api/getSearchData', payload)
        } else if (query.length === 0) {
          this.$store.commit('api/SET_SEARCH_RESULT_DATA', {})
        }
      }
      this.backupQuery = query
    }
  },
  watch: {
    '$store.state.api.searchData' (val) {

      const data = {
        restaurants: {
          key: 'title',
          data: []
        },
        products: {
          key: 'title',
          data: []
        }
      }

      val.map(item => {
        const search_page = {title: item.user_property['Restaurant-Name'], icon: 'HomeIcon', url: `/restaurants/${item.user_property['Alias']}`, is_bookmarked: false}
        data.restaurants.data.push(search_page)

        item.products.map(product => {
          const search_product = {title: `${product.name} in ${item.user_property['Restaurant-Name']}`, icon:'PageIcon', url: `/restaurants/${item.user_property['Alias']}/${product.id}`, is_bookmarked: false}
          data.products.data.push(search_product)
        })
      })

      this.$store.commit('api/SET_SEARCH_RESULT_DATA', data)
      this.isSearching = false
    },
    isSearching () {
      if (!this.isSearching && this.backupQuery !== this.sentQuery) {
        this.hnd_search_query_update(this.backupQuery)
      }
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.api.isMobile
    },
    searchResultData () {
      return this.$store.state.api.searchResultData
    }
  }
}

</script>
<style lang="scss">
#TheSearchBar {
  border:1px solid #ccc;
  width: calc(100% - 100px);
    border-radius: 25px;
    height: 37px;
    overflow: hidden;
}
  .searchbar-wrapper
  {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    border:1px solid #ccc;
    background:#f2f2f2;
    display: flex;
    align-items: flex-end;
    flex:1;
    span {

    }
  }

  .filter-wrapper {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    background:#f2f2f2;
    display: flex;
    align-items: flex-end;
    span {

    }
  }
  .feather-icon svg {
    width: 20px;
    height: 20px;
  }
  .mobile .margin-fix {
    margin-right: 0 !important;
  }
  .mobile .searchbar-wrapper {
    max-width: unset;
  }
</style>
